import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { scrollToSection } from "@/lib/scroll";

const TABS = [
  {
    key: "niche",
    label: "Niche Finder",
    title: "Spot profitable niches before you build",
    body: "Score any idea's market potential with revenue estimates, competition and live rankings.",
    img: "https://static.prod-images.emergentagent.com/jobs/2e8e3301-4fe4-4859-a4b5-fd0c272c7f7b/images/8ecc003ac8ee586767409bd46809f05d18ac4015095ab2eec7a7aac6075bafd3.jpeg",
    href: "#niche",
  },
  {
    key: "builder",
    label: "App Builder",
    title: "Real working apps, built by chatting",
    body: "Describe your idea and get a live, interactive app you can use, refine and publish.",
    img: "https://static.prod-images.emergentagent.com/jobs/2e8e3301-4fe4-4859-a4b5-fd0c272c7f7b/images/14737a9375e45bce67ad6b53f12e3c19aa58ce92dff92c353770232fd0fbdda9.jpeg",
    href: "#chat",
  },
  {
    key: "ads",
    label: "Ad Library",
    title: "Copy winning ad creatives",
    body: "Browse high-performing ad formats from top apps and model what already converts.",
    img: "https://static.prod-images.emergentagent.com/jobs/2e8e3301-4fe4-4859-a4b5-fd0c272c7f7b/images/1d8c3adddd277303c3339484873d6cb20a1a0c1dc87f3973903fe561c282387d.jpeg",
    href: "#features",
  },
];

export default function Examples() {
  const [active, setActive] = useState("niche");
  const tab = TABS.find((t) => t.key === active);

  return (
    <section id="examples" className="py-28 md:py-36 border-t border-white/10 relative overflow-hidden">
      <div className="pointer-events-none absolute right-0 top-1/3 w-[36rem] h-[36rem] bg-[#0055FF]/10 blur-[130px] rounded-full" />
      <div className="max-w-6xl mx-auto px-6 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4">/ showcase</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight">See it in action</h2>
        </motion.div>

        <div className="flex items-center justify-center gap-2 mb-10 flex-wrap">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              className={`font-mono text-xs md:text-sm uppercase tracking-widest px-5 py-2.5 rounded-full transition-colors duration-300 ${
                active === t.key ? "bg-[#0055FF] text-white" : "text-slate-400 border border-white/10 hover:text-white"
              }`}
              data-testid={`example-tab-${t.key}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.4 }}
            className="rounded-3xl border border-white/10 bg-[#0a0a0a] overflow-hidden"
            data-testid="example-panel"
          >
            <div className="grid md:grid-cols-2 items-center">
              <div className="p-10 md:p-14 order-2 md:order-1">
                <h3 className="font-display font-bold text-3xl mb-4 leading-tight">{tab.title}</h3>
                <p className="text-slate-400 leading-relaxed mb-8">{tab.body}</p>
                <button
                  onClick={() => scrollToSection(tab.href)}
                  className="inline-flex items-center gap-2 bg-white text-black px-6 py-3.5 rounded-2xl font-semibold hover:bg-[#00F0FF] transition-colors duration-300"
                  data-testid="example-cta"
                >
                  Try {tab.label} →
                </button>
              </div>
              <div className="order-1 md:order-2 relative h-[300px] md:h-[420px]">
                <img src={tab.img} alt={tab.title} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-transparent to-transparent md:block hidden" />
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
}
